// components/windows/wint/HandlePromo.js
import React, { useEffect, useState } from 'react';
import ShowJsonImage from './windows/wint/ShowJsonImage';
import './handle_promo.css';
import './handle_promo_extra.css';
import { authFetch, authFetchRequest } from './utils/api';
import { getCookie } from './utils/cookies';
import { alertC } from './components/dialogService';
import CustomPromoDialog from './CustomPromoDialog';
import CompanyHeader from './docs/company_header';
import { useAppFlags } from './utils/AppFlagsContext';

import { GetPrice } from './docs/getPrice';
import CloneConfigPanel from './CloneConfigPanel';
import SpecsSection from './SpecsSection';
import { formatT } from './utils/formatting';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';

//const HandlePromo = ({ quoteId, showLinePrices = true, documentType, isOpen }) => {
  const HandlePromo = ({
    quoteId,
    quoteDataWrapper,    // 👈 from wrapper
    itemQuotesWrapper,   // 👈 from wrapper
    promotionsWrapper,     // ← ADD
    financingWrapper,      // ← ADD
    crmPromotionsWrapper,  // ← ADD
    onSaveWrapper,       // 👈 from wrapper
    packageIdWrapper,    // 👈 from wrapper
    showLinePrices,
    documentType,
    isOpen,
  }) => {
  // Global feature flags. When BOTH promotions_enabled and financing_enabled
  // are false, the right-side .property-panel column is hidden entirely
  // (see the gated render around line 935). When only one is off, the
  // panel still renders but the corresponding section inside is skipped.
  const { flags: appFlags } = useAppFlags();
  const promotionsEnabled = !!appFlags.promotions_enabled;
  const financingEnabled = !!appFlags.financing_enabled;
  const promoFinancingEnabled = promotionsEnabled || financingEnabled;

  const [isReadOnly, setIsReadOnly] = useState(false);
  const [showCustomPromo, setShowCustomPromo] = useState(false);
  const [quoteRecord, setQuoteRecord] = useState(null);
  const [customerInfo, setCustomerInfo] = useState(null);
  const [quoteItemsData, setQuoteItemsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const [promotionsData, setPromotionsData] = useState(promotionsWrapper || []);
  const [selectedPromoId, setSelectedPromoId] = useState('');

  const [financingData, setFinancingData] = useState(financingWrapper || []);
  const [selectedFinancingId, setSelectedFinancingId] = useState('');
  const [financingDetails, setFinancingDetails] = useState(null);
  const [purchaseDate, setPurchaseDate] = useState('');
  const [deposit, setDeposit] = useState(0);
  const [monthlyPayment, setMonthlyPayment] = useState(0);

  const [recalcKey, setRecalcKey] = useState(0);
  const [didApplySavedPromos, setDidApplySavedPromos] = useState(false);
  const [quoteLoaded, setQuoteLoaded] = useState(false);
  const [itemsLoaded, setItemsLoaded] = useState(false);

  const [grandSubtotal, setGrandSubtotal] = useState(0);
  const [grandTax, setGrandTax] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [quoteData, setQuoteData] = useState({});

  const [debugDoublePrice, setDebugDoublePrice] = useState({});
  const [cloneOverrides, setCloneOverrides] = useState({
    glazingType1: null,
    glassEnergy1: null,
    glassStrength1: null
  });
  const [excludedItems, setExcludedItems] = useState({});

  const [triggerExpand, setTriggerExpand] = useState(0);
  const [triggerCollapse, setTriggerCollapse] = useState(0);

  const handleExpandAll = () => {
    setTriggerExpand(prev => prev + 1);
    setTriggerCollapse(0);        // ← reset collapse
  };
  
  const handleCollapseAll = () => {
    setTriggerCollapse(prev => prev + 1);
    setTriggerExpand(0);          // ← reset expand
  };
  const controlRef = React.useRef(null);
  // SKIP ALL LOADING FOR PACKAGE 2+ WORKS!
  if (false && packageIdWrapper > 1 && quoteDataWrapper && itemQuotesWrapper) {
    console.log(`[Package ${packageIdWrapper}] Skipping fetch — using wrapper data`);
    
    // Set everything immediately
    useEffect(() => {
      setQuoteRecord(quoteDataWrapper);
    }, [quoteDataWrapper]);

    useEffect(() => {
      setQuoteItemsData(itemQuotesWrapper);
    }, [itemQuotesWrapper]);

    useEffect(() => {
      if (promotionsWrapper) setPromotionsData(promotionsWrapper);
    }, [promotionsWrapper]);
    
    useEffect(() => {
      if (financingWrapper) setFinancingData(financingWrapper);
    }, [financingWrapper]);

    useEffect(() => {
      setIsLoading(false);
      setQuoteLoaded(true);
      setItemsLoaded(true);
    }, []);

    useEffect(() => {
      if (packageIdWrapper > 1 && quoteItemsData.length > 0) {
        console.log('%c[TRIGGER] cloneOverrides changed → recalculating all', 'color: #9c27b0', cloneOverrides);
    
        const result = recalculateAllWithPromos(quoteItemsData, quoteRecord?.crm_promotions || []);
        setQuoteItemsData(result.updatedItems);
        setGrandSubtotal(result.subtotalSum);
        setGrandTax(result.taxSum);
        setGrandTotal(result.totalSum);
      }
    }, [cloneOverrides, packageIdWrapper, quoteItemsData.length]);
    // Return early — skip all API logic
  }
  
  // ——————————————————————————————————————
  // CLONE MODE: USE WRAPPER DATA
  // ——————————————————————————————————————
  useEffect(() => {
    if (packageIdWrapper > 1 && quoteDataWrapper && itemQuotesWrapper) {
      console.log(`[Package ${packageIdWrapper}] Initializing from wrapper`);
      setQuoteRecord(quoteDataWrapper);
      setQuoteItemsData(itemQuotesWrapper);
      setQuoteLoaded(true);
      setItemsLoaded(true);
      setIsLoading(false);
    }
  }, [packageIdWrapper, quoteDataWrapper, itemQuotesWrapper]);

  // ——————————————————————————————————————
  // RECALCULATE ON CLONE OVERRIDES CHANGE
  // ——————————————————————————————————————
  useEffect(() => {
    if (packageIdWrapper > 1 && quoteItemsData.length > 0) {
      console.log('%c[CLONE] Recalculating due to override change', 'color: #9c27b0', cloneOverrides);
  
      const result = recalculateAllWithPromos(quoteItemsData, quoteRecord?.crm_promotions || []);
      
      setQuoteItemsData([...result.updatedItems]); // NEW ARRAY
      setGrandSubtotal(result.subtotalSum);
      setGrandTax(result.taxSum);
      setGrandTotal(result.totalSum);
    }
  }, [cloneOverrides, packageIdWrapper, quoteItemsData.length, quoteRecord?.crm_promotions]);

  // ——————————————————————————————————————
  // Initialize from wrapper when in clone mode
  // ——————————————————————————————————————
  useEffect(() => {
    if (packageIdWrapper > 1 && quoteDataWrapper && itemQuotesWrapper) {
      console.log(`[Package ${packageIdWrapper}] Initializing from wrapper`);
      setQuoteRecord(quoteDataWrapper);
      setQuoteItemsData(itemQuotesWrapper);
      setQuoteLoaded(true);
      setItemsLoaded(true);
      setIsLoading(false);
    }
  }, [packageIdWrapper, quoteDataWrapper, itemQuotesWrapper]);

  // --------------------------------------------------------------
  // 1. FINANCING LOGIC
  // --------------------------------------------------------------
  useEffect(() => {
    if (!financingDetails || grandTotal <= 0) return;

    const months = financingDetails.months || 1;
    const rate = (financingDetails.interest_rate || 0) / 100 / 12;
    const principal = grandTotal - deposit;

    const payment =
      rate === 0
        ? principal / months
        : (principal * rate) / (1 - Math.pow(1 + rate, -months));

    setMonthlyPayment(payment.toFixed(2));
  }, [financingDetails, deposit, grandTotal]);

  useEffect(() => {
    if (!selectedFinancingId) {
      setFinancingDetails(null);
      setMonthlyPayment(0);
      return;
    }
    const selected = financingData.find(f => f.id === Number(selectedFinancingId));
    setFinancingDetails(selected);
  }, [selectedFinancingId, financingData]);


const recalculateAllWithPromos = (items, currentPromos = []) => {
  let subtotalSum = 0;
  let taxSum = 0;
  let totalSum = 0;

  const updatedItems = items.map((item) => {
  let itemCopy = JSON.parse(JSON.stringify(item));

    // ——— FREEZE ITEM: SKIP ALL CHANGES (price + promo) ———
    if (packageIdWrapper > 1 && excludedItems[item.id]) {
      console.log(`%c[FROZEN] Item ${item.id} — completely skipped`, 'color: red; font-weight: bold');
      return itemCopy; // ← NOTHING TOUCHES THIS ITEM
    }

    // ——— STEP 0: FORCE RECALC FULL PRICE FOR ALL LINES (WHEN PROMO ACTIVE) ———
    if (currentPromos.length > 0) {
      console.log('%c[ALL TABS] Recalculating full base price for promo apply', 'color: red; font-weight: bold');

      itemCopy.doorData.calc.visibleLines = itemCopy.doorData.calc.visibleLines.map(([key, val]) => {
        let newVal = { ...val };
        if (!newVal.price) newVal.price = {};

        const cleanText = newVal.html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();

        // ——— BUILD OVERRIDE DOOR DATA (ALL 3 FIELDS) ———
        const overrideDoorData = {
          ...itemCopy.doorData,
          glass: {
            ...(itemCopy.doorData.glass || {}),
            glazingType1: cloneOverrides.glazingType1 || itemCopy.doorData.glass?.glazingType1,
            glassEnergy1: cloneOverrides.glassEnergy1 ? { value: cloneOverrides.glassEnergy1.value, label: cloneOverrides.glassEnergy1.label } : itemCopy.doorData.glass?.glassEnergy1,
            glassStrength1: cloneOverrides.glassStrength1 ? { value: cloneOverrides.glassStrength1.value, label: cloneOverrides.glassStrength1.label } : itemCopy.doorData.glass?.glassStrength1,
          }
        };

        const fullPrice = GetPrice({
          templateName: itemCopy.doorData.quoteTemplate,
          dataId: key,
          doorData: overrideDoorData,
          templates: itemCopy.doorData.templates || [],
          returnOnlyPrice: true
        });

        newVal.price.price = fullPrice.price;
        newVal.price.original = null;
        newVal.price.recalculated = null;

        console.log(`%c[RECALC BASE] ${cleanText}`, 'color: cyan', {
          key, fullPrice: fullPrice.price
        });

        return [key, newVal];
      });
    }
    // ——— LOOP 1: GLASS OVERRIDE (TEXT + PRICE) ———
    itemCopy.doorData.calc.visibleLines = itemCopy.doorData.calc.visibleLines.map(([key, val]) => {
      let newVal = { ...val };
      if (!newVal.price) newVal.price = {};

      const cleanText = newVal.html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();

      // ——— GLAZING TYPE ———
      if (packageIdWrapper > 1 && cleanText.includes('Glazing type:') && cloneOverrides.glazingType1) {
        const selected = cloneOverrides.glazingType1;
        const originalPrice = newVal.price.price ?? 0;

        const overrideDoorData = {
          ...itemCopy.doorData,
          glass: {
            ...(itemCopy.doorData.glass || {}),
            glazingType1: selected,
            glassEnergy1: cloneOverrides.glassEnergy1 ? { value: cloneOverrides.glassEnergy1.value, label: cloneOverrides.glassEnergy1.label } : itemCopy.doorData.glass?.glassEnergy1,
            glassStrength1: cloneOverrides.glassStrength1 ? { value: cloneOverrides.glassStrength1.value, label: cloneOverrides.glassStrength1.label } : itemCopy.doorData.glass?.glassStrength1,
          }
        };

        const newPrice = GetPrice({
          templateName: itemCopy.doorData.quoteTemplate,
          dataId: key,
          doorData: overrideDoorData,
          templates: itemCopy.doorData.templates || [],
          returnOnlyPrice: true
        });

        newVal.html = newVal.html.replace(
          /(Glazing type: )[^<]+/,
          `$1${selected}`
        );

        newVal.price = {
          price: newPrice.price,
          original: newVal.price.original,
          recalculated: originalPrice
        };

        console.log(`%c[GLAZING OVERRIDE] ${selected}`, 'color: gold', { key, from: originalPrice, to: newPrice.price });
      }

      // ——— GLASS ENERGY ———
      else if (packageIdWrapper > 1 && cleanText.includes('Glass Energy:') && cloneOverrides.glassEnergy1) {
        const selected = cloneOverrides.glassEnergy1;
        const originalPrice = newVal.price.price ?? 0;

        const overrideDoorData = {
          ...itemCopy.doorData,
          glass: {
            ...(itemCopy.doorData.glass || {}),
            glazingType1: cloneOverrides.glazingType1 || itemCopy.doorData.glass?.glazingType1,
            glassEnergy1: { value: selected.value, label: selected.label },
            glassStrength1: cloneOverrides.glassStrength1 ? { value: cloneOverrides.glassStrength1.value, label: cloneOverrides.glassStrength1.label } : itemCopy.doorData.glass?.glassStrength1,
          }
        };

        const newPrice = GetPrice({
          templateName: itemCopy.doorData.quoteTemplate,
          dataId: key,
          doorData: overrideDoorData,
          templates: itemCopy.doorData.templates || [],
          returnOnlyPrice: true
        });

        newVal.html = newVal.html.replace(
          /(Glass Energy: )[^<]+/,
          `$1${selected.label}`
        );

        newVal.price = {
          price: newPrice.price,
          original: newVal.price.original,
          recalculated: originalPrice
        };

        console.log(`%c[ENERGY OVERRIDE] ${selected.label}`, 'color: gold', { key, from: originalPrice, to: newPrice.price });
      }

      // ——— GLASS STRENGTH ———
      else if (packageIdWrapper > 1 && cleanText.includes('Glass strength:') && cloneOverrides.glassStrength1) {
        const selected = cloneOverrides.glassStrength1;
        const originalPrice = newVal.price.price ?? 0;

        const overrideDoorData = {
          ...itemCopy.doorData,
          glass: {
            ...(itemCopy.doorData.glass || {}),
            glazingType1: cloneOverrides.glazingType1 || itemCopy.doorData.glass?.glazingType1,
            glassEnergy1: cloneOverrides.glassEnergy1 ? { value: cloneOverrides.glassEnergy1.value, label: cloneOverrides.glassEnergy1.label } : itemCopy.doorData.glass?.glassEnergy1,
            glassStrength1: { value: selected.value, label: selected.label },
          }
        };

        const newPrice = GetPrice({
          templateName: itemCopy.doorData.quoteTemplate,
          dataId: key,
          doorData: overrideDoorData,
          templates: itemCopy.doorData.templates || [],
          returnOnlyPrice: true
        });

        newVal.html = newVal.html.replace(
          /(Glass strength: )[^<]+/,
          `$1${selected.label}`
        );

        newVal.price = {
          price: newPrice.price,
          original: newVal.price.original,
          recalculated: originalPrice
        };

        console.log(`%c[STRENGTH OVERRIDE] ${selected.label}`, 'color: gold', { key, from: originalPrice, to: newPrice.price });
      }

      return [key, newVal];
    });

    // ——— LOOP 2: PROMO LOGIC ONLY ———
    itemCopy.doorData.calc.visibleLines = itemCopy.doorData.calc.visibleLines.map(([key, val]) => {
      let newVal = { ...val };

      const cleanText = newVal.html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
      const matchedPromo = getMatchedPromo(currentPromos, cleanText);

      const currentPrice = Number(newVal.price.price ?? 0);
      const originalPrice = newVal.price.original ? Number(newVal.price.original) : null;

      if (matchedPromo && matchedPromo.applies_to !== 'subtotal_only') {
        if (originalPrice === null || Math.abs(currentPrice - originalPrice) > 0.01) {
          newVal.price = {
            original: currentPrice,
            price: calcPromotedPrice(matchedPromo, currentPrice)
          };
          console.log('PROMO APPLIED:', cleanText, currentPrice, '→', newVal.price.price);
        }
      } else if (!matchedPromo && originalPrice !== null) {
        newVal.price = {
          price: originalPrice,
          original: null
        };
        console.log('PROMO REMOVED:', cleanText, '→', originalPrice);
      }

      return [key, newVal];
    });

    // ——— STEP 2: Recalculate visible line subtotal (after line-item promos) ———
    const visiblePrices = itemCopy.doorData.calc.visibleLines
      .map(([_, v]) => v.price?.price ?? 0)
      .reduce((a, b) => a + Number(b), 0);

    let newSubtotal = visiblePrices;

    // ——— STEP 3: Handle SUBTOTAL-ONLY PROMOS ———
    const subtotalOnlyPromos = currentPromos.filter(p => p.applies_to === 'subtotal_only');

    if (subtotalOnlyPromos.length > 0) {
      itemCopy.doorData.calc.originalSubtotal = visiblePrices.toFixed(2);
      let discounted = newSubtotal;
      for (const promo of subtotalOnlyPromos) {
        if (promo.discount_type === '%') {
          discounted *= (1 - promo.discount / 100);
        } else {
          discounted -= promo.discount;
        }
        discounted = Math.max(discounted, 0);
      }
      console.log('CUSTOM PROMO APPLIED TO SUBTOTAL:', {
        itemId: itemCopy.id,
        original: visiblePrices.toFixed(2),
        final: discounted.toFixed(2),
        promos: subtotalOnlyPromos.map(p => p.name)
      });
      newSubtotal = discounted;
    } else {
      delete itemCopy.doorData.calc.originalSubtotal;
    }

    // ——— STEP 4: Finalize item totals ———
    const newTax = (newSubtotal * 0.13).toFixed(2);
    const newTotal = (newSubtotal + parseFloat(newTax)).toFixed(2);

    itemCopy.doorData.calc.subtotal = newSubtotal.toFixed(2);
    itemCopy.doorData.calc.tax = newTax;
    itemCopy.doorData.calc.total = newTotal;

    subtotalSum += newSubtotal;
    taxSum += parseFloat(newTax);
    totalSum += parseFloat(newTotal);

    return itemCopy;
  });

  return {
    updatedItems: [...updatedItems], // NEW ARRAY
    subtotalSum: Number(subtotalSum.toFixed(2)),
    taxSum: Number(taxSum.toFixed(2)),
    totalSum: Number(totalSum.toFixed(2))
  };
};
  // --------------------------------------------------------------
  // 3. SAVE PROMOTIONS
  // --------------------------------------------------------------
  const saveQuotePromotions = (promos) => {
    // 🔸 Clone mode: keep promos in wrapper state only
    if (packageIdWrapper > 1) {
      console.log(`[Package ${packageIdWrapper}] Saving promos locally`);
      setQuoteRecord(prev => ({ ...prev, crm_promotions: promos || [] }));
      return;
    }
    try {
      const payload = {
        table: "Quote",
        column: "crm_promotions",
        newValue: promos || [],
        id: quoteId
      };
      authFetchRequest(`/local/update`, payload, 'PUT', {
        Authorization: `Bearer ${getCookie('access_token')}`
      });
      console.log('Quote promotions saved');
    } catch (err) {
      console.error('Failed to save quote promotions', err);
    }
  };

  // --------------------------------------------------------------
  // 4. SAVE ITEMS (WITH original PRICE)
  // --------------------------------------------------------------
  const saveQuotesWithItems = (items) => {
    // 🔸 Clone mode → only update in-memory clone
    if (packageIdWrapper > 1) {
      console.log(`[Package ${packageIdWrapper}] Simulating saveQuotesWithItems (local only)`);
      setQuoteItemsData(items); // keep local
      return;
    }

    let failed = 0;
    for (const item of items) {
      const itemId = item.id || item.quoteItemId;
      if (!itemId) continue;

      try {
        const payload = {
          fkQuoteId: item.fkQuoteId || quoteId,
          doorData: item.doorData,
        };
        console.log('SAVING ITEM TO DB:', itemId, 'original prices:', 
          item.doorData?.calc?.visibleLines?.filter(([_, v]) => v.price?.original != null).map(([_, v]) => v.price.original)
        );
        authFetchRequest(`/itemquotes/${itemId}`, payload, 'PUT', {
          Authorization: `Bearer ${getCookie('access_token')}`
        });
      } catch (err) {
        failed++;
        console.error(`Failed to save item ${itemId}`, err);
      }
    }
  };

  // ——————————————————————————————————————
  // 5.0 ALWAYS RECALCULATE ON LOAD (with or without promos)
  // ——————————————————————————————————————  
  useEffect(() => {
    if (
      !didApplySavedPromos &&
      quoteLoaded &&
      itemsLoaded &&
      quoteItemsData.length > 0 &&
      quoteRecord?.crm_promotions?.length > 0
    ) {
      console.log('Applying saved promos on load:', quoteRecord.crm_promotions);

      //alert("Promotions in record Quote: " + JSON.stringify(quoteRecord, null, 2));
      const { updatedItems, subtotalSum, taxSum, totalSum } = recalculateAllWithPromos(
        quoteItemsData,
        quoteRecord.crm_promotions
      );

      setQuoteItemsData(updatedItems);
      setGrandSubtotal(subtotalSum);
      setGrandTax(taxSum);
      setGrandTotal(totalSum);
      //saveQuotesWithItems(updatedItems); // ← REMOVE THIS LINE
      setDidApplySavedPromos(true);
    }
    else {
      if (itemsLoaded && grandTotal === 0) {
        let subtotalSum = 0;
        let taxSum = 0;
        let totalSum = 0;
        const tempupdatedItems = quoteItemsData.map((item) => {
          // Safely get the totals
          const subtotal = Number(item?.doorData?.calc?.subtotal ?? 0);
          subtotalSum += subtotal;    
          const tax = Number(item?.doorData?.calc?.tax ?? 0);
          taxSum += tax; 
          const total = Number(item?.doorData?.calc?.total ?? 0);
          totalSum += total;         
        });
        setGrandSubtotal(subtotalSum);
        setGrandTax(taxSum);
        setGrandTotal(totalSum);

      }
    }
    
  }, [didApplySavedPromos, quoteLoaded, itemsLoaded, quoteItemsData, quoteRecord?.crm_promotions]);
  
  
// ——————————————————————————————————————
// 6. API CALLS — ONLY FOR BASE (Package 1)
// ——————————————————————————————————————
useEffect(() => {
  // SKIP FOR PACKAGE 2+
  if (packageIdWrapper > 1) {
    console.log(`[Package ${packageIdWrapper}] Skipping API calls — using wrapper`);
    return;
  }

  if (!quoteId) return;

  setDidApplySavedPromos(false);
  setQuoteLoaded(false);
  setItemsLoaded(false);
  setQuoteItemsData([]);
  setQuoteRecord(null);
  setIsLoading(true);
  setError(null);

  fetchQuoteRecord(quoteId);
  fetchQuoteItemsData(quoteId);
  fetchPromotions();
  fetchFinancing();
}, [quoteId, packageIdWrapper]);

  useEffect(() => {
    if (quoteRecord?.fkCustomerId) {
      fetchCustomerInfo(quoteRecord.fkCustomerId);
    }
  }, [quoteRecord]);

  const fetchPromotions = async () => {
    try {
      const data = await authFetch('/promotions/');
      setPromotionsData(data.filter(p => p.visible));
    } catch (err) {
      console.error('fetchPromotions error:', err);
      setError('Failed to load promotions.');
    }
  };

  const fetchFinancing = async () => {
    try {
      const data = await authFetch('/financing/');
      setFinancingData(data.filter(f => f.active));
    } catch (err) {
      console.error('fetchFinancing error:', err);
      setError('Failed to load financing options.');
    }
  };

  const fetchQuoteItemsData = async (id) => {
    if (packageIdWrapper > 1) {
      console.log(`[Package ${packageIdWrapper}] Using cloned item data`);
      return; // clones already get data from wrapper
    }
    try {
      const data = await authFetch(`/itemquotes/byquote/${id}`);
      const cleaned = data.map(item => {
        const clone = JSON.parse(JSON.stringify(item));
        
        if (clone.doorData?.calc?.visibleLines) {
          clone.doorData.calc.visibleLines.forEach(([_, val]) => {
            // ---- line-item original price ----
            if (val.price?.original != null) {
              console.log('LOADED ITEM WITH ORIGINAL (KEEPING):', val.price.original);
              val.price.price = Number(val.price.price);
            } else if (val.price?.price != null) {
              val.price.price = Number(val.price.price);
            }
          });

          // ---- subtotal-only original price ----
          if (clone.doorData.calc.originalSubtotal != null) {
            console.log('LOADED ITEM WITH originalSubtotal (KEEPING):', clone.doorData.calc.originalSubtotal);
            // keep it as string (same format we store)
            clone.doorData.calc.originalSubtotal = String(clone.doorData.calc.originalSubtotal);
          }
        }

        return clone;
      });
      setQuoteItemsData(cleaned);
      setItemsLoaded(true);
    } catch (err) {
      console.error('fetchQuoteItemsData error:', err);
      setError('Failed to load quote items.');
    } finally {
      setIsLoading(false);
    }
  };

  const fetchQuoteRecord = async (id) => {
    // 🔸 Clone mode
    if (packageIdWrapper > 1) {
      console.log(`[Package ${packageIdWrapper}] Using wrapper quote record`);
      // For clones, just pull from in-memory data already passed via wrapper
      return;
    }
    try {
      const data = await authFetch(`/quotes/${id}`);
      setQuoteRecord(data);
      setQuoteLoaded(true);
      setIsReadOnly(data.status !== 'Quote');
    } catch (err) {
      console.error('fetchQuoteRecord error:', err);
      setError('Failed to load quote record.');
    }
  };

  const fetchCustomerInfo = async (customerId) => {
    try {
      const data = await authFetch(`/customers/${customerId}`);
      setCustomerInfo(data);
    } catch (err) {
      console.error('fetchCustomerInfo error:', err);
    }
  };

  // --------------------------------------------------------------
  // 7. PROMO HELPERS
  // --------------------------------------------------------------
  const calcPromotedPrice = (promo, price) => {
    if (!promo) return Number(price.toFixed(2));
    if (promo.discount_type === '%') {
      return Number((price * (1 - promo.discount / 100)).toFixed(2));
    }
    if (promo.discount_type === 'amount') {
      return Number(Math.max(price - promo.discount, 0).toFixed(2));
    }
    return Number(price.toFixed(2));
  };

  const getMatchedPromo = (promos, text) => {
    if (!text) return null;
    const normalized = text
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .replace(/[\u2022\u2023\u25AA\u25CF\u25CB\u25A0\u25A1\u25A2\u25FD\u25FE\u25FB\u25FC\u25FF\u2713\u2714\u2715\u2716\u2717\u2718\u2719\u272A\u272B\u272C\u272D\u2730\u2731\u2732\u2733\u2734\u2735\u2736\u2737\u2738\u2739\u273A\u273B\u273C\u273D\u273E\u273F\u2740\u2741\u2742\u2743\u2744\u2745\u2746\u2747\u2748\u2749\u274A\u274B\u274C\u274D\u274E\u274F\u2750\u2751\u2752\u2753\u2754\u2755\u2756\u2757\u2758\u2759\u275A\u275B\u275C\u275D\u275E\u275F\u2760\u2761\u2762\u2763\u2764\u2765\u2766\u2767✔]/g, '')
      .replace(/\t+/g, ' ')
      .replace(/\s+/g, '')
      .trim()
      .toLowerCase();

    for (const p of promos) {
      if (!p.visible) continue;
      const applies = p.applies_to?.trim();
      if (!applies) continue;

      const subRules = applies.split('<>').map(r => r.trim()).filter(Boolean);
      for (const rule of subRules) {
        if (!rule.includes(':')) continue;
        const normalizedRule = rule.replace(/[\u2022\u2713\u2714✔]/g, '').replace(/\s+/g, '').trim().toLowerCase();
        if (normalizedRule.endsWith(':*')) {
          const prefix = normalizedRule.slice(0, -2);
          if (normalized.startsWith(prefix + ':')) return p;
        }
        if (normalized.includes(normalizedRule)) return p;
      }
    }
    return null;
  };

  const handleCustomPromoSave = (customPromo) => {
    const updated = [...assignedPromos, customPromo];
    setQuoteRecord(prev => ({ ...prev, crm_promotions: updated }));
  
    const { updatedItems, subtotalSum, taxSum, totalSum } = recalculateAllWithPromos(
      quoteItemsData,
      updated
    );
  
    setQuoteItemsData(updatedItems);
    setGrandSubtotal(subtotalSum);
    setGrandTax(taxSum);
    setGrandTotal(totalSum);
  
    saveQuotesWithItems(updatedItems);
    saveQuotePromotions(updated);
  };
  // --------------------------------------------------------------
  // 8. RENDER
  // --------------------------------------------------------------
  if (isLoading) return <div className="content-container">Loading...</div>;
  if (error) return <div className="content-container error">{error}</div>;

  const assignedPromos = quoteRecord?.crm_promotions || [];
  const validExpirations = assignedPromos
    .map(p => new Date(p.expiration_date))
    .filter(d => !isNaN(d));
  const earliestExpiration = validExpirations.length > 0
    ? new Date(Math.min(...validExpirations))
    : null;
  
  if (quoteData && Object.keys(quoteData).length === 0){
    if (quoteRecord?.created_at) {
        const date = new Date(quoteRecord?.created_at);
        quoteData.orderDate = new Intl.DateTimeFormat("en-US", {
          dateStyle: "medium", // "short" | "medium" | "long" | "full"
        }).format(date);
        quoteData.orderNumber = quoteRecord?.orderNumber || quoteRecord?.id || "N/A";
        quoteData.reference = quoteRecord?.reference_no || "N/A";
        quoteData.customer = customerInfo;
    }
  }
  //need this line to pass customer email to email dialog via DialogModalFinancing
  HandlePromo.customerEmail = customerInfo?.email || null;

  return (
    <div className="content-container" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
      {packageIdWrapper > 1 && (
      <CloneConfigPanel 
        cloneOverrides={cloneOverrides}
        setCloneOverrides={setCloneOverrides}
      />
      )}

      {quoteItemsData.map((item, idx) => (
        <div
        key={item.id}
        className="pdf-capture"
        >
        {/* COMPANY HEADER */}
        <CompanyHeader
          documentType="Quote"
          quoteData={quoteData}
          companyName="Eticom"
          
          customer={customerInfo}
        />

          <div className="specs-header-stripe">
            {earliestExpiration ? (
              <div className="expiration-banner">
                <strong>Quote is valid until:</strong>{' '}
                {earliestExpiration.toLocaleDateString(undefined, {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </div>
            ) : (
              <div className="expiration-banner-placeholder" />
            )}

            {idx === 0 && (
              <div ref={controlRef} className="specs-master-control">
                <button onClick={handleExpandAll} className="master-toggle-btn" title="Expand All Specs">
                  <UnfoldMoreIcon fontSize="small" />
                </button>
                <button onClick={handleCollapseAll} className="master-toggle-btn" title="Collapse All Specs">
                  <UnfoldLessIcon fontSize="small" />
                </button>
              </div>
            )}
          </div>
          
          <div className="warehouse-grid">

          <div className="image-column">
                {/* Image wrapper — forces proper spacing */}
                <div className="image-cell">
                  <ShowJsonImage
                    quoteId={quoteId}
                    quoteItemId={item.id || item.quoteItemId}
                    zoom={0.75}
                    doorData={packageIdWrapper > 1 ? item.doorData : null}
                  />
                </div>

                {/* Notes card — only shows when there is content */}
                {true && (item?.doorData?.notes?.LocationTag || item?.doorData?.notes?.notes) && (
                  <div className="notes-card">
                    {item.doorData.notes.LocationTag && (
                      <div className="notes-card__location">
                        Location: <span>{item.doorData.notes.LocationTag}</span>
                      </div>
                    )}

                    {item.doorData.notes.notes && (
                      <div className="notes-card__notes">
                        Notes: <span>{item.doorData.notes.notes}</span>
                      </div>
                    )}
                  </div>
                )}
          </div>

          <div className="specs-cell">
            <h4 className="specs-cell__title">
              Item #{idx + 1} - {item?.doorData?.frameData?.name}
              {packageIdWrapper > 1 && (
                <>
                  <span className="package-exclude">exclude</span>
                    <input
                      type="checkbox"
                      id={`exclude-${item.id}`}
                      className="exclude-checkbox"
                      checked={excludedItems[item.id] || false}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setExcludedItems(prev => ({
                          ...prev,
                          [item.id]: checked
                        }));
                        setRecalcKey(prev => prev + 1);
                      }}
                    />
                  </>
                )}
              </h4>

              {item?.doorData?.calc?.visibleLines?.length > 0 && (
                <SpecsSection
                  item={item}
                  expandAll={triggerExpand}
                  collapseAll={triggerCollapse}
                  productType={item?.doorData?.document?.type || 'windows'}
                  promos={quoteRecord?.crm_promotions || []}
                />
              )}

              {showLinePrices && item.price && <p>Price: ${item.price.toFixed(2)}</p>}

              <div className="item-summary-card">
                <div className="line">
                  <span><strong>Quantity:</strong></span>
                  <span>{item?.doorData?.frameData?.quantity || 'NA'}</span>
                </div>

                <div className="line">
                  <span><strong>Subtotal:</strong></span>
                  <span>
                    ${item?.doorData?.calc?.subtotal || '0.00'}
                    {item?.doorData?.calc?.originalSubtotal && (
                      <>
                        <s className="original-price">
                          ${item.doorData.calc.originalSubtotal}
                        </s>
                        <span className="promo-info">
                          (
                          {(() => {
                            const subtotalPromos =
                              quoteRecord?.crm_promotions?.filter(
                                p => p.applies_to === 'subtotal_only'
                              ) || [];
                            return subtotalPromos
                              .map(p => {
                                const type =
                                  p.discount_type === '%'
                                    ? `${p.discount}%`
                                    : `$${p.discount}`;
                                return `${type} Off Subtotal${
                                  p.name ? ` – ${p.name}` : ''
                                }`;
                              })
                              .join(', ');
                          })()}
                          )
                        </span>
                      </>
                    )}
                  </span>
                </div>

                <div className="line">
                  <span><strong>Tax:</strong></span>
                  <span>${item?.doorData?.calc?.tax || '0.0'}</span>
                </div>

                <div className="line">
                  <span><strong>Total:</strong></span>
                  <span>${item?.doorData?.calc?.total || '0.00'}</span>
                </div>
              </div>
            </div>

            {promoFinancingEnabled && idx === 0 && <div className="property-panel">
          {promotionsEnabled && <>
          <h3>Current Promotions</h3>

          <div className="promo-select-container">
            <label htmlFor="promoSelect">Select Promotion:</label>
            <select id="promoSelect" 
                    disabled={isReadOnly} 
                    value={selectedPromoId} 
                    onChange={(e) => setSelectedPromoId(e.target.value)}
            >
              <option value="">-- Choose a promotion --</option>
              {promotionsData.map((p) => (
                <option key={p.id} value={p.id}>{p.name || `Promo #${p.id}`}</option>
              ))}
            </select>

            {/* CUSTOM PROMO BUTTON */}
            <button
              onClick={() => setShowCustomPromo(true)}
              disabled={isReadOnly}
              className="custom-promo-button"
            >
              + Custom Promotion
            </button>


            <div className="installed-promotions-section">
              <h4 className="installed-promotions-title">Installed Promotions</h4>

              {assignedPromos.length === 0 ? (
                <p className="promotions-empty">No promotions assigned.</p>
              ) : (
                <ul className="promotions-list">
                  {assignedPromos.map((p) => (
                    <li key={p.id} className="promotion-item">
                      <span>{p.name}</span>
                      <button
                        disabled={isReadOnly}  
                        onClick={() => {
                          const updated = assignedPromos.filter((x) => x.id !== p.id);
                          setQuoteRecord(prev => ({ ...prev, crm_promotions: updated }));

                          const { updatedItems, subtotalSum, taxSum, totalSum } = recalculateAllWithPromos(quoteItemsData, updated);
                          setQuoteItemsData(updatedItems);
                          setGrandSubtotal(subtotalSum);
                          setGrandTax(taxSum);
                          setGrandTotal(totalSum);

                          saveQuotesWithItems(updatedItems);
                          saveQuotePromotions(updated);
                        }}
                        style={{ 
                          background: 'transparent', 
                          border: 'none', 
                          color: '#d32f2f', 
                          fontWeight: 'bold', 
                          cursor: isReadOnly ? 'not-allowed' : 'pointer',
                          fontSize: '1.3rem', 
                          lineHeight: '1',
                          margin: '0',               // ← no unwanted margin
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          minWidth: '24px',          // optional: consistent size
                          height: '24px',             // optional: even better alignment
                          padding: '0 6px' 
                        }}
                        title="Remove promotion"
                      >×</button>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>

          <button
            disabled={isReadOnly}
            onClick={() => {
              if (!selectedPromoId) return;
              const promo = promotionsData.find((p) => p.id === Number(selectedPromoId));
              if (!promo) return;

              const already = assignedPromos.some((p) => p.id === promo.id);
              if (already) {
                alertC('This promotion is already applied.');
                return;
              }

              const updated = [...assignedPromos, promo];
              setQuoteRecord((prev) => ({ ...prev, crm_promotions: updated }));

              const { updatedItems, subtotalSum, taxSum, totalSum } = recalculateAllWithPromos(quoteItemsData, updated);
              setQuoteItemsData(updatedItems);
              setGrandSubtotal(subtotalSum);
              setGrandTax(taxSum);
              setGrandTotal(totalSum);

              saveQuotesWithItems(updatedItems);
              saveQuotePromotions(updated);
              setSelectedPromoId('');
            }}
          >
            Apply Promo
          </button>
          </>}

          <div className="grand-totals-box">
            <strong>Grand Totals:</strong>
            <div className="line">
              <span>Subtotal:</span>
              <span>${formatT(grandSubtotal || 0)}</span>
            </div>
            <div className="line">
              <span>Tax:</span>
              <span>${formatT(grandTax || 0)}</span>
            </div>
            <div className="line">
              <span>Total:</span>
              <span>${formatT(grandTotal || 0)}</span>
            </div>
          </div>

          {financingEnabled && <>
          <h3>Financing Options</h3>
          <div className="promo-select-container">
            <label htmlFor="financingSelect">Select Financing Option:</label>
            <select id="financingSelect" 
                    disabled={isReadOnly}
                    value={selectedFinancingId} 
                    onChange={(e) => setSelectedFinancingId(e.target.value)}
            >
              <option value="">-- Choose an option --</option>
              {financingData.map((f) => (
                <option key={f.id} value={f.id}>{f.name || `Financing #${f.id}`}</option>
              ))}
            </select>
          </div>

            {financingDetails && (
                <div className="financing-box">
                  <p><strong>Provider:</strong> {financingDetails.provider}</p>
                  <p><strong>Term:</strong> {financingDetails.months} months at {financingDetails.interest_rate}%</p>
                  <label>Purchase Date: <input type="date" value={purchaseDate} onChange={(e) => setPurchaseDate(e.target.value)} /></label><br />
                  <label>Deposit ($): <input type="number" value={deposit} min="0" step="0.01" onChange={(e) => setDeposit(parseFloat(e.target.value) || 0)} /></label><br />
                  <p><strong>Grand Total:</strong> ${formatT(grandTotal || 0)}</p>
                  <p><strong>Monthly Payment:</strong> <span className="monthly-payment">${monthlyPayment}</span></p>
                  {financingDetails.website_url && (
                    <p><a href={financingDetails.website_url} target="_blank" rel="noopener noreferrer">Financing Provider Website</a></p>
                  )}
                  {financingDetails.expiration_date && (
                    <div className="financing-expiration-notice">
                      <strong>Offer valid until:</strong>{' '}
                      {new Date(financingDetails.expiration_date).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })}
                    </div>
                  )}
                </div>
            )}
          </>}
          </div> } {/* end .property-panel */}

              {/* DEBUG: Double Price for Triple Lines */}
              {Object.keys(debugDoublePrice).length > 0 && (
                <div className="debug-double-price">
                  <strong>DEBUG: Triple to Double Price (Clone Tabs)</strong>
                  <pre>
                    {JSON.stringify(debugDoublePrice, null, 2)}
                  </pre>
                </div>
              )}
          </div> {/* end .warehouse-grid */}
  
          {/* ——— GRAND TOTALS (NO GAP) ——— */}
          {idx === -1 && <div className="grand-totals-section">
            <h3>Grand Totals (Quote #{quoteId})</h3>
            <p>
              <strong>Subtotal:</strong> ${formatT(grandSubtotal)}
            </p>
            <p>
              <strong>Tax:</strong> ${formatT(grandTax || 0)}
            </p>
            <p className="total-line">
              <strong>Total:</strong> ${formatT(grandTotal || 0)}
            </p>
          </div>}
        </div>
        ))}

        {/* FINAL GRAND TOTALS PAGE */}
        {quoteItemsData.length > 0 && (
          <div className="pdf-capture final-grand-totals-page">
            <CompanyHeader
              documentType="Quote"
              quoteData={quoteData}
              companyName="Eticom"
              
              customer={customerInfo}
            />

            <div className="final-grand-totals-wrapper">
              <div className="final-grand-totals-box">
                <span><strong>Grand Totals:</strong></span>
                <div className="final-grand-totals-line subtotal"></div>
                <div className="final-grand-totals-line">
                  <span>Subtotal:</span>
                  <span>${formatT(grandSubtotal || 0)}</span>
                </div>
                <div className="final-grand-totals-line">
                  <span>Tax:</span>
                  <span>${formatT(grandTax || 0)}</span>
                </div>
                <div className="final-grand-totals-line total">
                  <span><strong>Total:</strong></span>
                  <span>${formatT(grandTotal || 0)}</span>
                </div>
              </div>
            </div>
          </div>
        )}
      <CustomPromoDialog
        isOpen={showCustomPromo}
        onClose={() => setShowCustomPromo(false)}
        onSave={handleCustomPromoSave}
      />
    </div>
  );
};

export default HandlePromo;